import * as React from "react"
import injectSheet from "react-jss"
import { color } from "@xingternal/360-styles/helpers"
import { randomInt } from "@/helpers"

const styles = {
  barChart: {
    composes: "flex items-end",
    height: ({ height }) => height,
    padding: ({ padding }) => padding,
  },
  barWrap: { composes: "f1 overflow-hidden" },
  bar: {
    composes: "bg-gray-10",
    backgroundImage: `linear-gradient(to right, ${color("gray-10")} 8%, ${color(
      "gray-15",
    )} 38%, ${color("gray-10")} 54%)`,
    marginLeft: "18%",
    marginRight: "18%",
    animationDuration: "3s",
    animationIterationCount: "infinite",
    animationName: "barChartSkeletonShimmer",
    animationTimingFunction: "linear",
    backgroundSize: "1200px 8px",
  },
  "@keyframes barChartSkeletonShimmer": {
    from: { backgroundPosition: "-1200px 0" },
    to: { backgroundPosition: "1200px 0" },
  },
}

const LoadingBarChart = ({ bars, classes, height, padding }) => (
  <div className={classes.barChart}>
    {[...Array(bars)].map((e, i) => (
      <div className={classes.barWrap} key={i}>
        <div
          className={classes.bar}
          style={{
            height: randomInt(10, height - padding * 2),
            animationDelay: `${parseInt((i / 5) * 1000, 10)}ms`,
          }}
        />
      </div>
    ))}
  </div>
)

LoadingBarChart.defaultProps = { bars: 7, height: 312, padding: 32 }

export const StyledLoadingBarChart = injectSheet(styles)(LoadingBarChart)
export default LoadingBarChart
